An array of SEEK position profile identifiers assigned after sync.
